import { getRootContainerProps } from "@client/content/lib/helper";
import { ModuleButton } from "@client/content/modules/Button";
import { SecondaryButton } from "@client/content/shared/Buttons";
import { type RootContainerProps } from "@client/content/types";
import TextArea from "@client/controls/Inputs/TextArea/component";
import { EMPTY_OBJECT } from "@client/lib/misc";
import Messages from "@common/components/AiChat/Messages";
import { type AiChatValue } from "@common/components/AiChat/types";
import { FormButtons, FormControlled, type FormControlledRenderParams, FormField } from "@common/controls/Form/component";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";

type FormData = {
  message: string;
};

type Props = RootContainerProps & {
  chat: AiChatValue;
  onChatsClick?: () => void;
  onNewChatClick?: () => void;
  onSendMessage: (message: string) => void;
};
export default ({ chat, ...props }: Props) => {
  const i18n = useI18n();

  const submit = React.useCallback((data: FormData) => props.onSendMessage(data.message), [props.onSendMessage]);

  return (
    <>
      {!!chat.data.length && <Messages data={chat.data} agentName={chat.agentName} isNarrow />}

      <FormControlled resetOnSubmit="pre" defaultValues={EMPTY_OBJECT} submit={submit}>
        {({ isSubmitting, submit, values, onChange }: FormControlledRenderParams<FormData>) => (
          <>
            <FormField
              Component={TextArea}
              componentProps={{
                placeholder: i18n.askAnything,
                enterMode: "shift",
                onEnter: submit
              }}
              isRequired
              name="message"
              value={values.message}
            />

            <FormButtons align="space_between">
              <ModuleButton {...getRootContainerProps(props)} isDisabled={isSubmitting} onClick={submit} />

              <div className="extra_buttons">
                {!!props.onNewChatClick && (
                  <SecondaryButton
                    {...getRootContainerProps(props)}
                    onClick={() => {
                      onChange("message", "");
                      props.onNewChatClick!();
                    }}
                  >
                    {i18n.newChat}
                  </SecondaryButton>
                )}
                {!!props.onChatsClick && (
                  <SecondaryButton {...getRootContainerProps(props)} onClick={props.onChatsClick}>
                    {i18n.allChats}
                  </SecondaryButton>
                )}
              </div>
            </FormButtons>
          </>
        )}
      </FormControlled>
    </>
  );
};
